import { Level2MenuHead, Level2MenuItem } from "@/features";
import { IoSettingsOutline } from "react-icons/io5";
import { PiBuildingOfficeLight } from "react-icons/pi";
import React, { ReactElement, useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import type { GgMeType } from "@/types";
import {
  getRoleTypeNameFromUser,
  permissionsCompanyMenu,
  permissionsUsersReadonly,
  permissionsCompaniesReadonly,
  permissionsDeveloper,
  permissionsLocationsReadonly,
} from "@/utils";

const parentPath = "corporate-group";

interface PointOfContactsMenuProps {
  user?: GgMeType | null;
}

export const PointOfContactsMenu = ({
  user,
}: PointOfContactsMenuProps): ReactElement | null => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const roleType = getRoleTypeNameFromUser(user);

  if (roleType !== "company" && roleType !== "super") {
    return null;
  }

  return (
    <Level2MenuHead
      link={`/${parentPath}`}
      label={
        roleType === "company"
          ? gettext("Settings")
          : gettext("Corporate Groups")
      }
      codes={permissionsCompanyMenu}
      feature="common"
      icon={
        <>
          {roleType === "company" && (
            <IoSettingsOutline size={18} className="mx-3" />
          )}
          {roleType !== "company" && (
            <PiBuildingOfficeLight size={18} className="mx-3" />
          )}
        </>
      }
    >
      <Level2MenuItem
        link={`/${parentPath}/company-users`}
        label={gettext("Users")}
        codes={permissionsUsersReadonly}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/companies`}
        label={gettext("Companies")}
        codes={permissionsCompaniesReadonly}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/locations`}
        label={gettext("Company Location")}
        codes={permissionsLocationsReadonly}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/settings`}
        label={gettext("Settings")}
        codes={permissionsDeveloper}
        feature="common"
      />
    </Level2MenuHead>
  );
};
